import { TableCell } from '@mui/material';
import { useStyles } from './reports/styles/ReportTable.styles';
import { SortDescendingIcon } from '@/assets';
import { SortDirection } from '@api/cut';

export const CutReportTableHeader = ({
    header,
    showSort,
    sortDirection,
    onSort,
}: {
    header: string;
    showSort: boolean;
    sortDirection?: SortDirection;
    onSort: (direction: SortDirection) => void;
}) => {
    const classes = useStyles();

    return showSort ? (
        <TableCell
            align='left'
            style={{ width: '20%' }}
            onClick={() => {
                const newDirection =
                    sortDirection === SortDirection.Ascending ? SortDirection.Descending : SortDirection.Ascending;
                onSort(newDirection);
            }}>
            <div className={classes.tableHeaderCell}>
                {header}
                {sortDirection === SortDirection.Descending ? (
                    <SortDescendingIcon style={{ marginLeft: '5px' }} />
                ) : (
                    <SortDescendingIcon
                        style={{
                            transform: 'rotate(180deg)',
                            marginLeft: '5px',
                        }}
                    />
                )}
            </div>
        </TableCell>
    ) : (
        <TableCell align='left' style={{ width: '20%' }}>
            <div className={classes.tableHeaderCell}>{header}</div>
        </TableCell>
    );
};
